import { render, staticRenderFns } from "./CustomerActionsMobile.vue?vue&type=template&id=4c173089&"
import script from "./CustomerActionsMobile.vue?vue&type=script&lang=ts&"
export * from "./CustomerActionsMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports